// Copyright 2021 the .NET Foundation
// Licensed under the MIT License
/** Type guard function for [[GenericSetting]]. */
export function isGenericSetting(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]' &&
        obj.length == 2 &&
        typeof obj[0] === "string";
}
const appSettingTypeInfo = {
    "hideAllChrome/boolean": true,
};
/** Type guard function for [[AppSetting]]. */
export function isAppSetting(obj) {
    const key = obj[0] + "/" + typeof obj[1];
    return (key in appSettingTypeInfo);
}
/** A type-guard-like function for the app mode of [[ModifySettingsMessage]].
 *
 * @param o An object that might be a [[ModifySettingsMessage]]
 * @returns A list of recognized [[AppSetting]]s in the message if so; otherwise null
 *
 * This function is like a type guard for the [[ModifySettingsMessage]]
 * interface, with the additional constraint that it only matches messages
 * targeting the overall app. If that is the case, it returns an array of the
 * settings that matched this package's knowledge of acceptable app settings.
 * Unrecognized settings are filtered out from the return value.
 *
 * If the message does not seem to be a settings-modification message, null is
 * returned.
 */
export function maybeAsModifiedAppSettings(o) {
    if (o.event !== "modify_settings" || o.target !== "app")
        return null;
    if (Object.prototype.toString.call(o.settings) !== '[object Array]')
        return null;
    const accepted = [];
    for (const item of o.settings) {
        if (isGenericSetting(item) && isAppSetting(item)) {
            accepted.push(item);
        }
    }
    return accepted;
}
